// SNIGJ - Payment Cancel Page
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import DashboardLayout from '../components/layout/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';

const PaymentCancelPage = () => {
  const { language } = useAuth();
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <div className="max-w-lg mx-auto mt-10" data-testid="payment-cancel-page">
        <Card className="text-center">
          <CardHeader>
            <div className="flex justify-center mb-4">
              <XCircle className="w-20 h-20 text-orange-500" />
            </div>
            <CardTitle className="text-2xl">
              {language === 'fr' ? 'Paiement annulé' : 'Payment Cancelled'}
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <p className="text-muted-foreground">
              {language === 'fr'
                ? 'Votre paiement a été annulé. Aucun montant n\'a été débité de votre compte.'
                : 'Your payment was cancelled. No amount has been charged to your account.'}
            </p>

            <div className="flex gap-3 justify-center">
              <Button variant="outline" onClick={() => navigate('/citizen')} className="gap-2">
                <ArrowLeft className="w-4 h-4" />
                {language === 'fr' ? 'Retour au portail' : 'Back to Portal'}
              </Button>
              <Button onClick={() => navigate('/citizen?tab=fees')} className="gap-2">
                <RefreshCw className="w-4 h-4" />
                {language === 'fr' ? 'Réessayer' : 'Try Again'}
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default PaymentCancelPage;
